import { useState, useEffect } from "react";
import imageBestGear from "../../assets/shared/desktop/image-best-gear.jpg";
import imageBestGearTab from "../../assets/shared/tablet/image-best-gear.jpg";
import imageBestGearMobile from "../../assets/shared/mobile/image-best-gear.jpg";
import classes from "./BestGear.module.scss";

const BestGear = () => {
  const [imgBestGear, setImgBestGear] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 450) {
        setImgBestGear(imageBestGearMobile);
      } else if (window.innerWidth <= 768) {
        setImgBestGear(imageBestGearTab);
      } else {
        setImgBestGear(imageBestGear);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className={`${classes.product_container} ${classes.container}`}>
      <div
        className={`${classes.product_description} ${classes.flexStartItem}`}
      >
        <div className={classes.product_description_content}>
          <h1 className={classes.product_name}>
            Bringing you the <span className={classes.best_text}>best</span>{" "}
            audio gear
          </h1>
          <p className={classes.product_text}>
            Located at the heart of New York City, Audiophile is the premier
            store for high-end headphones, earphones, speakers, and audio
            accessories. We have a large showroom and luxury demonstration rooms
            available for you to browse and experience a wide range of our
            products. Stop by our store to meet some of the fantastic people who
            make Audiophile the best place to buy your portable audio equipment.
          </p>
        </div>
      </div>
      <div className={classes.product_img}>
        <img src={imgBestGear} alt="product_img" />
      </div>
    </section>
  );
};

export default BestGear;
